// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"lMnRF":[function(require,module,exports,__globalThis) {
// Contact Form - EmailJS Integration
// Handles form submission to send emails via EmailJS service
// Initialize EmailJS with public key
emailjs.init('70rEsPXlc8tY_Abu-');
const form = document.querySelector('.contact-form');
const submitButton = form?.querySelector('.contact-form-submit');
const buttonLabel = submitButton?.querySelector('.button__label');
// Store original button text
const originalButtonText = buttonLabel?.textContent || 'SEND';
// Handle form submission
if (form && submitButton) form.addEventListener('submit', async (e)=>{
    e.preventDefault();
    // Check if already sending
    if (submitButton.disabled) return;
    // Get form data
    const formData = new FormData(form);
    const data = {
        from_name: formData.get('name'),
        from_email: formData.get('email'),
        message: formData.get('message')
    };
    // Validate data
    if (!data.from_name || !data.from_email || !data.message) {
        showMessage('Please fill in all fields', 'error');
        return;
    }
    try {
        // Update button state to loading
        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
        if (buttonLabel) buttonLabel.textContent = 'SENDING...';
        // Send email via EmailJS
        const response = await emailjs.send('service_m1gwikt', 'template_7fuo8f1', data);
        console.log('Email sent successfully:', response);
        // Show success message
        showMessage('Message sent successfully! I\'ll get back to you soon.', 'success');
        // Reset form after short delay
        setTimeout(()=>{
            form.reset();
        }, 500);
    } catch (error) {
        console.error('Failed to send email:', error);
        showMessage('Failed to send message. Please try again or email me directly.', 'error');
    } finally{
        // Reset button state
        submitButton.disabled = false;
        submitButton.classList.remove('is-loading');
        if (buttonLabel) buttonLabel.textContent = originalButtonText;
    }
});
// Show temporary message to user
function showMessage(text, type = 'success') {
    // Remove any existing messages
    const existingMessage = document.querySelector('.form-message');
    if (existingMessage) existingMessage.remove();
    // Create message element
    const message = document.createElement('div');
    message.className = `form-message form-message--${type}`;
    message.textContent = text;
    // Insert after form
    form.parentNode.insertBefore(message, form.nextSibling);
    // Fade in
    requestAnimationFrame(()=>{
        message.classList.add('is-visible');
    });
    // Remove after 5 seconds
    setTimeout(()=>{
        message.classList.remove('is-visible');
        setTimeout(()=>message.remove(), 300);
    }, 5000);
}

},{}]},["lMnRF"], "lMnRF", "parcelRequire8c58", {})

//# sourceMappingURL=jribh.github.io.85d2ba2a.js.map
